export default {
  data() {
    return {
      whichIndex: 0, // 动态显示左侧菜单栏高亮
      leftArr: [], // 左侧菜单栏的数据
      rightArr: [], // 右侧详情展示对应的数据
      rightHeightArr: [], // 右侧每一项的高度数组
      rightHeightSumArr: [], // 右侧每一项的高度累加数组
      r: 0, // 滚动的距离     
      leftHeightArr: [],// 左侧每一项的高度数组
      leftHeightSumArr: [], // 右侧每一项的高度累加数组
      newIntroduce: "",
      state: "",
      menuId: "B01-1-4",
      newMEnu1: [
        { //BTC币种         
          label: "BTC币种",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "B1",
          children: [
            {
              //地址统计
              path: "/",
              label: "menu.onchain2",
              fullName: "menu.onchain2",
              icon: "i igl-folderOpen",
              componentReq: "newAddress2",
              radius: "btc",
              id: "B01-1-4",
              introduce: "introduce.address",
              navigation: "newAddress",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //盈利地址数
              path: "/",
              label: "menu.profitAddress",
              fullName: "menu.profitAddress",
              icon: "i igl-folderOpen",
              componentReq: "profitAddress",
              radius: "btc",
              id: "B01-1-1",
              introduce: "introduce.profitAddress",
              navigation: "profitAddress",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //匿名用户
            },
            {
              //亏损地址数
              path: "/",
              label: "menu.lossAddress",
              fullName: "menu.lossAddress",
              icon: "i igl-folderOpen",
              componentReq: "lossAddress",
              radius: "btc",
              id: "B01-1-2",
              introduce: "introduce.lossAddress",
              navigation: "lossAddress",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //匿名用户
            },
            {
              //地址盈亏比
              path: "/",
              label: "menu.profitRatio",
              fullName: "menu.profitRatio",
              icon: "i igl-folderOpen",
              componentReq: "profitRatio",
              radius: "btc",
              id: "B01-1-3",
              introduce: "introduce.profitRatio",
              navigation: "profitRatio",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //匿名用户
            },

            {
              //暂时注释 持有比特币超过100个的地址列表 改为 巨鲸地址列表 无权限
              path: "/",
              label: "menu.onchain15",
              fullName: "menu.onchain15",
              icon: "i igl-folderOpen",
              componentReq: "getTopList",
              radius: "btc",
              id: "B01-1-5",
              introduce: "introduce.getTopList",
              navigation: "topList", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //发行价值（USD) 改为日发行价值 中英文都是 puell multiple
              path: "/",
              label: "menu.technology38",
              fullName: "menu.technology38",
              icon: "i igl-folderOpen",
              componentReq: "mintusd",
              radius: "btc",
              id: "B02-1-1",
              introduce: "introduce.mintusd",
              navigation: "mintusd", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户"
            },
            {
              //矿工地址数 与矿工地址余额 合并 改为矿工余额
              path: "/",
              label: "menu.onchain20",
              fullName: "menu.technology38",
              icon: "i igl-folderOpen",
              componentReq: "minerAddress",
              radius: "btc",
              id: "B02-1-2",
              introduce: "introduce.minerAddress",
              navigation: "minerAddress", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3", //1天
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //日交易统计 更改名字 交易统计
              path: "/",
              label: "menu.onchain19",
              fullName: "menu.onchain19",
              icon: "i igl-folderOpen",
              componentReq: "BTCVolume",
              radius: "btc",
              id: "B03-1-1",
              introduce: "introduce.BTCVolume",
              navigation: "volume", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //交易汇率乘数
              path: "/",
              label: "menu.frm",
              fullName: "menu.frm",
              icon: "i igl-folderOpen",
              componentReq: "frm",
              radius: "btc",
              id: "B03-1-2",
              introduce: "introduce.frm",
              navigation: "frm",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //流通供应量
              path: "/",
              label: "menu.technology21",
              fullName: "menu.technology21",
              icon: "i igl-folderOpen",
              componentReq: "csupply",
              radius: "btc",
              id: "B03-1-3",
              introduce: "introduce.csupply",
              navigation: "csupply", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              path: "/", //大额交易
              label: "menu.onchain1",
              fullName: "menu.onchain1",
              icon: "i igl-folderOpen",
              componentReq: "ethbigtxcount",
              radius: "btc",
              id: "B03-1-4",
              introduce: "introduce.btcbigtxcount",
              navigation: "bigDeals",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //待交易池详情
              path: "/",
              label: "menu.mempool",
              fullName: "menu.mempool",//全名 
              icon: "i igl-folderOpen",
              componentReq: "mempool",
              radius: "btc",
              id: "B03-1-5",
              introduce: "introduce.mempool",
              navigation: "mempool", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",


            },
            {
              //长期持有者每日交易量
              path: "/",
              label: "menu.lthVolume",//简写
              fullName: "menu.lthVolume2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthVolume",
              radius: "btc",
              id: "B04-1-1",
              introduce: "introduce.lthVolume",
              navigation: "lthVolume",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长期持有者供应量
              path: "/",
              label: "menu.lthSupply",
              fullName: "menu.lthSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthSupply",
              radius: "btc",
              id: "B04-1-2",
              introduce: "introduce.lthSupply",
              navigation: "lthSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长期持有者盈利总供应量 改为 长期持有者盈利供应量
              path: "/",
              label: "menu.lthProfitSupply",
              fullName: "menu.lthProfitSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthProfitSupply",
              radius: "btc",
              id: "B04-1-3",
              introduce: "introduce.lthProfitSupply",
              navigation: "lthProfitSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长期持有者亏损总供应量 改为 长期持有者亏损供应量
              path: "/",
              label: "menu.lthLossSupply",
              fullName: "menu.lthLossSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthLossSupply",
              radius: "btc",
              id: "B04-1-4",
              introduce: "introduce.lthLossSupply",
              navigation: "lthLossSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长期持有者盈亏比
              path: "/",
              label: "menu.lthProfitRatio",
              fullName: "menu.lthProfitRatio2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthProfitRatio",
              radius: "btc",
              id: "B04-1-5",
              introduce: "introduce.lthProfitRatio",
              navigation: "lthProfitRatio",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //短期持有者供应量
              path: "/",
              label: "menu.sthSupply",
              fullName: "menu.sthSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sthSupply",
              radius: "btc",
              id: "B04-1-13",
              introduce: "introduce.sthSupply",
              navigation: "sthSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //短期持有者盈利总供应量 改为短期持有者盈利供应量
              path: "/",
              label: "menu.sthProfitSupply",
              fullName: "menu.sthProfitSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sthProfitSupply",
              radius: "btc",
              id: "B04-1-6",
              introduce: "introduce.sthProfitSupply",
              navigation: "sthProfitSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //短期持有者亏损总供应量 改为短期持有者亏损供应量
              path: "/",
              label: "menu.sthLossSupply",
              fullName: "menu.sthLossSupply2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sthLossSupply",
              radius: "btc",
              id: "B04-1-7",
              introduce: "introduce.sthLossSupply",
              navigation: "sthLossSupply",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //短期持有者盈亏比
              path: "/",
              label: "menu.sthProfitRatio",
              fullName: "menu.sthProfitRatio2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sthProfitRatio",
              radius: "btc",
              id: "B04-1-8",
              introduce: "introduce.sthProfitRatio",
              navigation: "sthProfitRatio",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长/短期持有者供应量盈亏比
              path: "/",
              label: "menu.relativeLthSth",
              fullName: "menu.relativeLthSth2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "relativeLthSth",
              radius: "btc",
              id: "B04-1-9",
              introduce: "introduce.relativeLthSth",
              navigation: "relativeLthSth",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //短期到长期实现价值比率
              path: "/",
              label: "menu.SLRVRatio",
              fullName: "menu.SLRVRatio2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "SLRVRatio",
              radius: "btc",
              id: "B04-1-10",
              introduce: "introduce.SLRVRatio",
              navigation: "SLRVRatio",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //长持者流通市值-已实现流通市值比 改为 长期持有者 MVRV Ratio
              path: "/",
              label: "menu.technology30",
              fullName: "menu.lthmvrv",//全名 
              icon: "i igl-folderOpen",
              componentReq: "lthmvrv",
              radius: "btc",
              id: "B04-1-11",
              introduce: "introduce.lthmvrv",
              navigation: "lthmvrv", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //短持者流通市值-已实现流通市值比 改为 短期持有者 MVRV Ratio
              path: "/",
              label: "menu.technology31",
              fullName: "menu.sthmvrv",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sthmvrv",
              radius: "btc",
              id: "B04-1-12",
              introduce: "introduce.sthmvrv",
              navigation: "sthmvrv", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //流通市值
              path: "/",
              label: "menu.technology28",
              fullName: "menu.marketcap",//全名 
              icon: "i igl-folderOpen",
              componentReq: "marketcap",
              radius: "btc",
              id: "B05-1-1",
              introduce: "introduce.marketcap",
              navigation: "marketcap", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //  已实现流通市值  改为和流通市值合并显示在一个页面 后期修改拆分
              path: "/",
              label: "menu.technology29",
              fullName: "menu.rcap",//全名 
              icon: "i igl-folderOpen",
              componentReq: "rcap",
              radius: "btc",
              id: "B05-1-17",
              introduce: "introduce.rcap",
              navigation: "rcap", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest",

            },
            {
              //  已实现流通市值(找零消除)
              path: "/",
              label: "menu.earcap",
              fullName: "menu.earcap2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "earcap",
              radius: "btc",
              id: "B05-1-18",
              introduce: "introduce.earcap1",
              navigation: "earcap1", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",

            },
            {
              //新的MVRV 改名 MVRV Ratio

              path: "/",
              label: "menu.technology1",
              fullName: "menu.mvrv",//全名 
              icon: "i igl-folderOpen",
              componentReq: "market",
              radius: "mvrv",
              id: "B05-1-3",
              introduce: "introduce.MVRV",
              navigation: "mvrv",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //MVRVZ  MVRV Z-Score
              path: "/",
              label: "menu.technology2",
              fullName: "menu.technology2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "market",
              // req: "market",
              radius: "MVRVZ",
              coin: "BTC",
              id: "B05-1-4",
              introduce: "introduce.MVRVZ",
              navigation: "MVRVZ", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //流通速度
              path: "/",
              label: "menu.velocity",
              fullName: "menu.velocity",//全名            
              icon: "i igl-folderOpen",
              componentReq: "velocity",
              radius: "btc",
              id: "B05-1-2",
              introduce: "introduce.velocity",
              navigation: "velocity",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },

            {
              //已实现盈利量
              path: "/",
              label: "menu.technology25",
              fullName: "menu.technology25",//全名   
              icon: "i igl-folderOpen",
              componentReq: "rprofit",
              radius: "btc",
              id: "B05-1-5",
              formula: "",//介绍公式
              introduce: "introduce.rprofit",
              navigation: "rprofit", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //已实现亏损量
              path: "/",
              label: "menu.technology26",
              fullName: "menu.technology26",//全名   
              icon: "i igl-folderOpen",
              componentReq: "rloss",
              radius: "btc",
              id: "B05-1-6",
              introduce: "introduce.rloss",
              navigation: "rloss", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //已实现净收益损失比
              path: "/",
              label: "menu.technology27",
              fullName: "menu.technology27",//全名   
              icon: "i igl-folderOpen",
              componentReq: "rplRate",
              radius: "btc",
              id: "B05-1-7",
              introduce: "introduce.rplRate",
              navigation: "rplRate", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //已实现价格
              path: "/",
              label: "menu.realizedPrice",
              fullName: "menu.realizedPrice",//全名   
              icon: "i igl-folderOpen",
              componentReq: "realizedPrice",
              radius: "btc",
              id: "B05-1-8",
              introduce: "introduce.realizedPrice",
              navigation: "realizedPrice",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //已平衡价格
              path: "/",
              label: "menu.balancedPrice",
              fullName: "menu.balancedPrice",//全名   
              icon: "i igl-folderOpen",
              componentReq: "balancedPrice",
              radius: "btc",
              id: "B05-1-9",
              introduce: "introduce.balancedPrice",
              navigation: "balancedPrice",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //累积价值-销毁天数比
              path: "/",
              label: "menu.cvdd",
              fullName: "menu.cvdd2",//全名   
              icon: "i igl-folderOpen",
              componentReq: "cvdd",
              radius: "btc",
              id: "B05-1-10",
              introduce: "introduce.cvdd",
              navigation: "cvdd",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //未实现的净收益量
              path: "/",
              label: "menu.technology33",
              fullName: "menu.technology33",//全名  
              icon: "i igl-folderOpen",
              componentReq: "uprofit",
              radius: "btc",
              id: "B05-1-12",
              introduce: "introduce.uprofit",
              navigation: "uprofit", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //未实现的净亏损量
              path: "/",
              label: "menu.technology34",
              fullName: "menu.technology34",//全名  
              icon: "i igl-folderOpen",
              componentReq: "uloss",
              radius: "btc",
              id: "B05-1-13",
              introduce: "introduce.uloss",
              navigation: "uloss", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //未实现的净收益损失比
              path: "/",
              label: "menu.technology32",
              fullName: "menu.nupl",//全名  
              icon: "i igl-folderOpen",
              componentReq: "nupl",
              radius: "btc",
              id: "B05-1-11",
              introduce: "introduce.nupl",
              navigation: "nupl", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },



            {
              //长持者未实现的净收益量 改为 长持者未实现的净收益损失比
              path: "/",
              label: "menu.technology35",
              fullName: "menu.lthnupl",//全名  
              icon: "i igl-folderOpen",
              componentReq: "lthnupl",
              radius: "btc",
              id: "B05-1-14",
              introduce: "introduce.lthnupl",
              navigation: "lthnupl", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3", //改为1天
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //短持者未实现的净收益量  改为 短持者未实现的净收益损失比
              path: "/",
              label: "menu.technology36",
              fullName: "menu.sthnupl",//全名
              icon: "i igl-folderOpen",
              componentReq: "sthnupl",
              radius: "btc",
              id: "B05-1-15",
              introduce: "introduce.sthnupl",
              navigation: "sthnupl", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3", //改为1天
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //市值/交易价值比 NVT Ratio  改为 市盈率
              path: "/",
              label: "menu.nvtRatio",
              fullName: "menu.nvtRatio2",//全名
              icon: "i igl-folderOpen",
              componentReq: "nvtRatio",
              radius: "btc",
              id: "B05-1-16",
              introduce: "introduce.nvtRatio",
              navigation: "nvtRatio",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //NVT信号
              path: "/",
              label: "menu.nvtSign",
              fullName: "menu.nvtSign",//全名
              icon: "i igl-folderOpen",
              componentReq: "nvtSign",
              radius: "btc",
              id: "B05-1-19",
              introduce: "introduce.nvtSign",
              navigation: "nvtSign",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //已花费输出平均寿命
              path: "/",
              label: "menu.technology18",
              fullName: "menu.asol",//全名 
              icon: "i igl-folderOpen",
              componentReq: "asol",
              radius: "btc",
              id: "B06-1-1",
              introduce: "introduce.asol",
              navigation: "asol", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //币天销毁量
              path: "/",
              label: "menu.technology37",
              fullName: "menu.CDD",//全名 
              icon: "i igl-folderOpen",
              componentReq: "CDD",
              radius: "btc",
              id: "B06-1-2",
              introduce: "introduce.CDD",
              navigation: "CDD", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //币天销毁量年龄分布
              path: "/",
              label: "menu.technology20",
              fullName: "menu.soag",//全名 
              icon: "i igl-folderOpen",
              componentReq: "soag",
              radius: "btc",
              id: "B06-1-3",
              introduce: "introduce.soag",
              navigation: "soag", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //已花费输出休眠平均天数
              path: "/",
              label: "menu.technology19",
              fullName: "menu.technology19",//全名 
              icon: "i igl-folderOpen",
              componentReq: "dormancy",
              radius: "btc",
              id: "B06-1-4",
              introduce: "introduce.dormancy",
              navigation: "dormancy", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //活跃度
              path: "/",
              label: "menu.technology24",
              fullName: "menu.technology24",//全名 
              icon: "i igl-folderOpen",
              componentReq: "liveliness",
              radius: "btc",
              id: "B06-1-5",
              introduce: "introduce.Liveliness",
              navigation: "liveliness", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户"
            },
            {
              //已实现盈利交易占比
              path: "/",
              label: "menu.technology16",
              fullName: "menu.technology16",//全名 
              icon: "i igl-folderOpen",
              componentReq: "profitrate",
              radius: "btc",
              id: "B07-1-1",
              introduce: "introduce.profitrate",
              navigation: "profitrate", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //已花费输出盈利比
              path: "/",
              label: "menu.technology17",
              fullName: "menu.SOPR",//全名 
              icon: "i igl-folderOpen",
              componentReq: "sopr",
              radius: "btc",
              id: "B07-1-2",
              introduce: "introduce.sopr",
              navigation: "sopr", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //持有者地址数分布( 按余额分段) 改为 地址数分布
              path: "/",
              label: "menu.onchain5I",
              fullName: "menu.onchain5",//全名 
              icon: "i igl-folderOpen",
              componentReq: "utxos",
              radius: "btc",
              id: "B08-1-1-1",
              introduce: "introduce.balanceDistribution",
              navigation: "utxos",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者币数量分布(按余额分段) 改为 币数量分布
              path: "/",
              label: "menu.onchain6I",
              fullName: "menu.onchain6",//全名 
              icon: "i igl-folderOpen",
              componentReq: "utxos2nd",
              radius: "btc",
              id: "B08-1-1-2",
              introduce: "introduce.balanceDistribution",
              navigation: "utxos2nd",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者地址数分布( 按持有时间分段)  改为 地址数分布
              path: "/",
              label: "menu.onchain7I",
              fullName: "menu.onchain7",//全名 
              icon: "i igl-folderOpen",
              componentReq: "holder",
              radius: "btc",
              id: "B08-1-2-1",
              introduce: "introduce.timeDivision",
              navigation: "holder",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者币数量分布( 按持有时间分段) 改为 币数量分布
              path: "/",
              label: "menu.onchain8I",
              fullName: "menu.onchain8",//全名 
              icon: "i igl-folderOpen",
              componentReq: "holderBalance",
              radius: "btc",
              id: "B08-1-2-2",
              introduce: "introduce.timeDivision",
              navigation: "holderBalance",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者地址数分布( 按买入价格分段) 改为 地址数分布
              path: "/",
              label: "menu.onchain9I",
              fullName: "menu.onchain9",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getBuyData",
              radius: "btc",
              id: "B08-1-3-1",
              introduce: "introduce.priceDivision",
              navigation: "buyData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者币数量分布( 按买入价格分段) 改为 币数量分布
              path: "/", //与Buy Data共用
              label: "menu.onchain10I",
              fullName: "menu.onchain10",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getBuyAmountData",
              radius: "btc",
              id: "B08-1-3-2",
              introduce: "introduce.priceDivision",
              navigation: "buyData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者地址数分布(盈亏) 改为  地址数分布 按买卖价差划分
              path: "/",
              label: "menu.onchain11I",
              fullName: "menu.onchain11",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getDiffData",
              radius: "btc",
              id: "B08-1-4-1",
              introduce: "introduce.priceDivision",
              navigation: "diffData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者币数量分布(盈亏) 改为 币数量分布 按买卖价差划分
              path: "/", //与Diff Data共用
              label: "menu.onchain12I",
              fullName: "menu.onchain12",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getDiffAmountData",
              radius: "btc",
              id: "B08-1-4-2",
              introduce: "introduce.priceDivision",
              navigation: "diffData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者地址数分布(利润率)  改为 地址数分布 按盈利划分
              path: "/",
              label: "menu.onchain13I",
              fullName: "menu.onchain13",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getProfitData",
              radius: "btc",
              id: "B08-1-5-1",
              introduce: "introduce.profitDistribution",
              navigation: "profitData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //持有者币数量分布(利润率) 改为 币数量分布 按按盈利划分
              path: "/", //与Profit Data共用
              label: "menu.onchain14I",
              fullName: "menu.onchain14",//全名 
              icon: "i igl-folderOpen",
              componentReq: "getProfitAmountData",
              radius: "btc",
              id: "B08-1-5-2",
              introduce: "introduce.profitDistribution",
              navigation: "profitData", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            //地址详细分布
            {
              //余额>=0 and <0.01的地址 币龄分布表 改为 余额<0.01
              // path: "/",
              label: "menu.Currency2I",
              componentReq: "getDayBalanceData",
              fullName: "menu.balanceData1",//全名   
              radius: "btc",
              id: "B08-1-6-1",
              value: 0,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",   改为 余额>=0.01 & < 0.1
              label: "menu.Currency3I",
              componentReq: "getDayBalanceData",
              fullName: "menu.balanceData2",//全名   
              radius: "btc",
              id: "B08-1-6-2",
              value: 0.01,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",  改为 余额>=0.1 & < 1
              label: "menu.Currency4I",
              fullName: "menu.balanceData3",//全名   
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-3",
              value: 0.1,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",  余额>=1 & < 10
              label: "menu.Currency5I",
              fullName: "menu.balanceData4",//全名   
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-4",
              value: 1,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=10 & < 100
              label: "menu.Currency6I",
              fullName: "menu.balanceData5",//全名   
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-5",
              value: 10,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",余额>=100 & < 1000
              label: "menu.Currency7I",
              fullName: "menu.balanceData6",//全名   
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-6",
              value: 100,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=1000 & < 10000
              label: "menu.Currency8I",
              fullName: "menu.balanceData7",//全名  
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-7",
              value: 1000,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=10000
              label: "menu.Currency9I",
              fullName: "menu.balanceData8",//全名  
              componentReq: "getDayBalanceData",
              radius: "btc",
              id: "B08-1-6-8",
              value: 10000,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            //币数量详细分布
            {
              //余额>=0 and <0.01的币数量 币龄分布表 改为 余额<0.01
              // path: "/",
              label: "menu.Currency11I",
              fullName: "menu.balanceData9",//全名  
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-1",
              value: 0,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=0.01 & < 0.1
              label: "menu.Currency12I",
              fullName: "menu.balanceData10",//全名  
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-2",
              value: 0.01,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",余额>=0.1 & < 1
              label: "menu.Currency13I",
              fullName: "menu.balanceData11",//全名  
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-3",
              value: 0.1,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",  余额>=1 & < 10
              label: "menu.Currency14I",
              fullName: "menu.balanceData12",//全名 
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-4",
              value: 1,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=10 & < 100
              label: "menu.Currency15I",
              fullName: "menu.balanceData13",//全名 
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-5",
              value: 10,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",  余额>=100 & < 1000
              label: "menu.Currency16I",
              fullName: "menu.balanceData14",//全名 
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-6",
              value: 100,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/", 余额>=1000 & < 10000
              label: "menu.Currency17I",
              fullName: "menu.balanceData15",//全名 
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-7",
              value: 1000,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              // path: "/",  余额>=10000
              label: "menu.Currency18I",
              fullName: "menu.balanceData16",//全名 
              componentReq: "getDayBalanceAmountData",
              radius: "btc",
              id: "B08-1-7-8",
              value: 10000,
              introduce: "introduce.detailedDistribution",
              navigation: "balanceData",
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },
            {
              //江卓尔60日累计涨幅
              path: "/",
              label: "menu.technology6",
              fullName: "menu.jzr60",//全名 
              icon: "i igl-folderOpen",
              componentReq: "jzr60",
              radius: "btc",
              id: "2-1",
              // conditions: "arh", //不同请求方式筛选条件
              introduce: "introduce.jzr60",
              navigation: "jzr60",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //arh999囤币及逃顶指标
              path: "/",
              label: "menu.technology7",
              fullName: "menu.arh999",//全名 
              icon: "i igl-folderOpen",
              componentReq: "arh99",
              radius: "btc",
              id: "2-2",
              navigation: "arh999",
              // conditions: "arh", //不同请求方式筛选条件
              introduce: "introduce.arh999",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //2年移动平均价格乘数
              path: "/",
              label: "menu.technology11",
              fullName: "menu.ma730",//全名 
              icon: "i igl-folderOpen",
              componentReq: "ma730",
              radius: "btc",
              id: "2-4",
              introduce: "introduce.ma730",
              navigation: "ma730", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //币价当前市值排名
              path: "/",
              label: "menu.onchain17",
              fullName: "menu.coinmarketall",//全名 
              icon: "i igl-folderOpen",
              componentReq: "币价当前市值排名",
              radius: "btc",
              id: "2-5",
              introduce: "introduce.coinmarketall",
              navigation: "coinmarketall", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //PI周期顶指标
              path: "/",
              label: "menu.PiCycleTopIndicator",
              fullName: "menu.PiCycleTopIndicator",//全名 
              icon: "i igl-folderOpen",
              componentReq: "piCycleTop",
              radius: "btc",
              id: "2-9",
              introduce: "introduce.PiCycleTopIndicator",
              navigation: "piCycleTop", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //稳定币供应比
              path: "/",
              label: "menu.ssr",
              fullName: "menu.ssr",//全名 
              icon: "i igl-folderOpen",
              componentReq: "ssr",
              radius: "btc",
              id: "2-10",
              introduce: "introduce.ssr",
              navigation: "ssr", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //稳定币供应比振荡器
              path: "/",
              label: "menu.ssro",
              fullName: "menu.ssro",//全名 
              icon: "i igl-folderOpen",
              componentReq: "ssro",
              radius: "btc",
              id: "2-11",
              introduce: "introduce.ssro",
              navigation: "ssro", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //库存/新发行比
              path: "/",
              label: "menu.stfRatio",
              fullName: "menu.stfRatio",//全名 
              icon: "i igl-folderOpen",
              componentReq: "stfRatio",
              radius: "btc",
              id: "2-12",
              introduce: "introduce.stfRatio",
              navigation: "stfRatio", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest",
            },
            {
              //库存/新发行偏差
              path: "/",
              label: "menu.stfDeflection",
              fullName: "menu.stfDeflection",//全名 
              icon: "i igl-folderOpen",
              componentReq: "stfDeflection",
              radius: "btc",
              id: "2-13",
              introduce: "introduce.stfDeflection",
              navigation: "stfDeflection", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //黄金比例乘数
              path: "/",
              label: "menu.goldenRatioMult",
              fullName: "menu.goldenRatioMult",//全名 
              icon: "i igl-folderOpen",
              componentReq: "goldenRatioMult",
              radius: "btc",
              id: "2-14",
              introduce: "introduce.goldenRatioMult",
              navigation: "goldenRatioMult", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //纳斯达克指数
              path: "/",
              label: "menu.macro1",
              fullName: "menu.macro1",//全名 
              icon: "i igl-folderOpen",
              componentReq: "NDAQohlc",
              id: "3-1",
              introduce: "introduce.NDAQohlc",
              navigation: "ndaqOhlc",
              assets: "无",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //纳斯达克/BTC日K线 改为 纳斯达克指数 vs BTC
              path: "/",
              label: "menu.macro2",
              fullName: "menu.macro2",//全名 
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "3-2",
              introduce: "introduce.NDAQBTCPrice",
              navigation: "NdaqBtcDayKline",
              assets: "无",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //市场快讯 金十数据
              path: "/",
              label: "menu.quickNews",
              fullName: "menu.quickNews",//全名 
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "3-3",
              introduce: "introduce.quickNews",
              navigation: "quickNews",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //财经日历 金十数据
              path: "/",
              label: "menu.economics",
              fullName: "menu.economics",//全名 
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "3-4",
              introduce: "introduce.quickNews",
              navigation: "economics",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //资金费率
              path: "/",
              label: "menu.technology13",
              fullName: "menu.technology13",//全名 
              icon: "i igl-folderOpen",
              componentReq: "fundingRate",
              radius: "btc",
              id: "4-3",
              introduce: "introduce.fundingRate",
              navigation: "fundingRate", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //注册用户
            },
            {
              //未平仓合约数
              path: "/",
              label: "menu.technology14",
              fullName: "menu.technology14",//全名 
              icon: "i igl-folderOpen",
              componentReq: "openInterest",
              radius: "btc",
              id: "4-4",
              introduce: "introduce.openInterest",
              navigation: "openInterest", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },

            {
              //合约主动买入量
              path: "/",
              label: "menu.technology15",
              fullName: "menu.technology15",//全名 
              icon: "i igl-folderOpen",
              componentReq: "takerlongshortRatio",
              radius: "btc",
              id: "4-5",
              introduce: "introduce.takerlongshortRatio",
              navigation: "takerlongshortRatio", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //时区购买力
              path: "/",
              label: "menu.tzbp",
              fullName: "menu.tzbp",//全名 
              icon: "i igl-folderOpen",
              componentReq: "tzbp",
              radius: "btc",
              id: "4-6",
              introduce: "introduce.tzbp",
              navigation: "tzbp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //买入大单挂单
              path: "/",
              label: "menu.bobp",
              fullName: "menu.bobp",//全名 
              icon: "i igl-folderOpen",
              componentReq: "bobp",
              radius: "btc",
              id: "4-7",
              introduce: "introduce.bobp",
              navigation: "bobp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //卖出大单挂单
              path: "/",
              label: "menu.bosp",
              fullName: "menu.bosp",//全名 
              icon: "i igl-folderOpen",
              componentReq: "bosp",
              radius: "btc",
              id: "4-8",
              introduce: "introduce.bobp",//买入卖出都一样
              navigation: "bosp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //成交量分布图
              path: "/",
              label: "menu.volumeProfile",
              fullName: "menu.volumeProfile",//全名 
              icon: "i igl-folderOpen",
              componentReq: "volumeProfile",
              radius: "btc",
              id: "4-9",
              introduce: "introduce.volumeProfile",
              navigation: "volumeProfile", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //交易所余额
              path: "/",
              label: "menu.exchange10",
              fullName: "menu.exchange10",//全名 
              icon: "i igl-folderOpen",
              componentReq: "exchange",
              radius: "btc",
              id: "4-10",
              introduce: "introduce.exchange1",
              navigation: "exchange", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //长/短期持有者供应量盈亏分布
              path: "/",
              label: "menu.distributionLthSth",
              fullName: "menu.distributionLthSth", //全名
              icon: "i igl-folderOpen",
              componentReq: "distributionLthSth",
              radius: "btc",
              id: "B04-1-14",
              introduce: "introduce.distributionLthSth",
              navigation: "distributionLthSth", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance", //付费用户
            },

          ],
        },
        // { //ETH币种         
        //   label: "ETH币种",
        //   icon: "i itubiao2",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "E1",
        //   children: [
        //     {
        //       //地址统计
        //       path: "/",
        //       label: "menu.onchain2",
        //       fullName: "menu.onchain2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "address",
        //       radius: "eth",
        //       id: "E01-1-1",
        //       introduce: "introduce.ethAddress",
        //       navigation: "ethAddress",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //盈利地址数
        //       path: "/",
        //       label: "menu2.profit",
        //       fullName: "menu2.profit",
        //       icon: "i igl-folderOpen",
        //       componentReq: "profit",
        //       radius: "eth",
        //       id: "E01-1-3",
        //       introduce: "introduce.profitAddress",
        //       navigation: "profitEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //亏损地址数
        //       path: "/",
        //       label: "menu2.loss",
        //       fullName: "menu2.loss",
        //       icon: "i igl-folderOpen",
        //       componentReq: "loss",
        //       radius: "eth",
        //       id: "E01-1-4",
        //       introduce: "introduce.lossAddress",
        //       navigation: "lossEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //盈利地址百分比
        //       path: "/",
        //       label: "menu2.profitPercent",
        //       fullName: "menu2.profitPercent",
        //       icon: "i igl-folderOpen",
        //       componentReq: "profitPercent",
        //       radius: "eth",
        //       id: "E01-1-2",
        //       introduce: "introduce.profitPercentEth",
        //       navigation: "profitPercentEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },

        //     {
        //       //巨鲸地址跟踪 改为 巨鲸地址交易历史
        //       path: "/",
        //       label: "menu2.ethTopAddrMonitorList",
        //       fullName: "menu2.ethTopAddrMonitorList",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ethTopAddrMonitorList",
        //       radius: "eth",
        //       id: "E01-1-5",
        //       introduce: "introduce.ethTopAddrMonitorList", //无
        //       navigation: "ethTopAddrMonitorList",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //巨鲸列表 改为 巨鲸地址列表
        //       path: "/",
        //       label: "menu2.onchain2",
        //       fullName: "menu2.onchain2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ethTopAddrList",
        //       radius: "eth",
        //       id: "E01-1-6",
        //       introduce: "introduce.getTopList",
        //       navigation: "ethTopAddrList", //导航组件名称
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //日交易统计 更改名字 交易统计
        //       path: "/",
        //       label: "menu2.onchain19",
        //       fullName: "menu2.onchain19",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ETHVolume",
        //       radius: "btc",
        //       id: "E02-1-1",
        //       introduce: "introduce.ETHVolume",
        //       navigation: "Fees", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //交易费率乘数
        //       path: "/",
        //       label: "menu2.frm",
        //       fullName: "menu2.frm",
        //       icon: "i igl-folderOpen",
        //       componentReq: "frm",
        //       radius: "eth",
        //       id: "E02-1-2",
        //       introduce: "introduce.frm",
        //       navigation: "frmEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //燃烧量
        //       path: "/",
        //       label: "menu2.burnedSupply",
        //       fullName: "menu2.burnedSupply",
        //       icon: "i igl-folderOpen",
        //       componentReq: "burnedSupply",
        //       radius: "eth",
        //       id: "E02-1-3",
        //       introduce: "introduce.burnedSupplyEth",
        //       navigation: "burnedSupplyEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //发行量
        //       path: "/",
        //       label: "menu2.mintedSupply",
        //       fullName: "menu2.mintedSupply",
        //       icon: "i igl-folderOpen",
        //       componentReq: "mintedSupply",
        //       radius: "eth",
        //       id: "E02-1-4",
        //       introduce: "introduce.mintedSupplyEth",
        //       navigation: "mintedSupplyEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //新币发行量
        //       path: "/",
        //       label: "menu2.issuance",
        //       fullName: "menu2.issuance",
        //       icon: "i igl-folderOpen",
        //       componentReq: "issuance",
        //       radius: "eth",
        //       id: "E02-1-5",
        //       introduce: "introduce.issuanceEth",
        //       navigation: "issuanceEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //流通供应量
        //       path: "/",
        //       label: "menu.technology21",
        //       fullName: "menu.technology21",
        //       icon: "i igl-folderOpen",
        //       componentReq: "csupply",
        //       radius: "btc",
        //       id: "E02-1-6",
        //       introduce: "introduce.csupply",
        //       navigation: "csupply", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3", //历史数据
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //抵押奖励
        //       path: "/",
        //       label: "menu2.reward",
        //       fullName: "menu2.reward",
        //       icon: "i igl-folderOpen",
        //       componentReq: "reward",
        //       radius: "eth",
        //       id: "E02-1-7",
        //       introduce: "introduce.reward",
        //       navigation: "reward",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //通货膨胀率
        //       path: "/",
        //       label: "menu2.inflationRate",
        //       fullName: "menu2.inflationRate",
        //       icon: "i igl-folderOpen",
        //       componentReq: "inflactionRate",
        //       radius: "eth",
        //       id: "E02-1-8",
        //       introduce: "introduce.inflactionRateEth",
        //       navigation: "inflactionRateEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //新合约数
        //       path: "/",
        //       label: "menu2.cnew",
        //       fullName: "menu2.cnew",
        //       icon: "i igl-folderOpen",
        //       componentReq: "cnew",
        //       radius: "eth",
        //       id: "E02-1-9",
        //       introduce: "introduce.cnew",
        //       navigation: "cnew",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //新合约地址
        //       path: "/",
        //       label: "menu2.newContract",
        //       fullName: "menu2.newContract",
        //       icon: "i igl-folderOpen",
        //       componentReq: "newContract",
        //       radius: "eth",
        //       id: "E02-1-10",
        //       introduce: "introduce.newContract", //无
        //       navigation: "newContract",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //大额交易
        //       path: "/",
        //       label: "menu2.onchain1",
        //       fullName: "menu2.onchain1",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ethbigtxcount",
        //       radius: "eth",
        //       id: "E02-1-11",
        //       introduce: "introduce.btcbigtxcount",
        //       navigation: "bigDeals",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //erc20 token 日交易量 改为代币交易量
        //       path: "/",
        //       label: "menu2.large6",
        //       fullName: "menu2.large6",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ETHTokenVolume",
        //       radius: "eth",
        //       id: "E03-1-1",
        //       introduce: "introduce.ETHTokenVolume",
        //       navigation: "ercVolume",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },

        //     {
        //       //erc20 token 大额交易监控 改为 代币大额交易
        //       path: "/",
        //       label: "menu2.large5",
        //       fullName: "menu2.ercBigDeals",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ETHTokenBigtx",
        //       radius: "eth",
        //       id: "E03-1-2",
        //       introduce: "introduce.ETHTokenBigtx",
        //       navigation: "ercBigDeals",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //流通市值
        //       path: "/",
        //       label: "menu2.marketcap",
        //       fullName: "menu2.marketcap2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "marketcap",
        //       radius: "eth",
        //       id: "E04-1-1",
        //       introduce: "introduce.marketcap",
        //       navigation: "marketcapEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest",
        //     },
        //     {
        //       //已实现流通市值
        //       path: "/",
        //       label: "menu2.rcap",
        //       fullName: "menu2.rcap2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "rcap",
        //       radius: "eth",
        //       id: "E04-1-4",
        //       introduce: "introduce.rcapEth",
        //       navigation: "rcapEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //流通市值-已实现流通市值比 改为 MVRV Ratio
        //       path: "/",
        //       label: "menu2.mvrvRatio",
        //       fullName: "menu2.mvrvRatio2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "mvrvRatio",
        //       radius: "eth",
        //       id: "E04-1-11",
        //       introduce: "introduce.MVRV",
        //       navigation: "mvrvRatioEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //已实现价格
        //       path: "/",
        //       label: "menu2.rprice",
        //       fullName: "menu2.rprice",
        //       icon: "i igl-folderOpen",
        //       componentReq: "rprice",
        //       radius: "eth",
        //       id: "E04-1-5",
        //       introduce: "introduce.realizedPrice",
        //       navigation: "rpriceEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //市值/交易价值比 NVT Ratio 改为 市盈率
        //       path: "/",
        //       label: "menu2.nvtRatio",
        //       fullName: "menu2.nvtRatio2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "nvtRatio",
        //       radius: "eth",
        //       id: "E04-1-2",
        //       introduce: "introduce.nvtRatio",
        //       navigation: "nvtRatioEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //流通速度
        //       path: "/",
        //       label: "menu2.velocity",
        //       fullName: "menu2.velocity",
        //       icon: "i igl-folderOpen",
        //       componentReq: "velocity",
        //       radius: "eth",
        //       id: "E04-1-3",
        //       introduce: "introduce.velocity",
        //       navigation: "velocityEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //未实现的净收益量
        //       path: "/",
        //       label: "menu2.relativeUProfit",
        //       fullName: "menu2.relativeUProfit",
        //       icon: "i igl-folderOpen",
        //       componentReq: "relativeUProfit",
        //       radius: "eth",
        //       id: "E04-1-7",
        //       introduce: "introduce.uprofit",
        //       navigation: "relativeUProfitEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //未实现的净亏损量
        //       path: "/",
        //       label: "menu2.relativeULoss",
        //       fullName: "menu2.relativeULoss",
        //       icon: "i igl-folderOpen",
        //       componentReq: "relativeULoss",
        //       radius: "eth",
        //       id: "E04-1-8",
        //       introduce: "introduce.uloss",
        //       navigation: "relativeULossEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },

        //     {
        //       //未实现的净收益损失比
        //       path: "/",
        //       label: "menu2.nupl",
        //       fullName: "menu2.nupl2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "nupl",
        //       radius: "eth",
        //       id: "E04-1-6",
        //       introduce: "introduce.nupl",
        //       navigation: "nuplEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },

        //     {
        //       //长持者未实现的净收益量 修改为 长持者未实现的净收益损失比
        //       path: "/",
        //       label: "menu2.lthNUPL",
        //       fullName: "menu2.lthNUPL2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "lthNUPL",
        //       radius: "eth",
        //       id: "E04-1-9",
        //       introduce: "introduce.lthnupl",
        //       navigation: "lthNUPLEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //短持者未实现的净亏损量 改为 短持者未实现的净亏损损失比
        //       path: "/",
        //       label: "menu2.sthNUPL",
        //       fullName: "menu2.sthNUPL2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "sthNUPL",
        //       radius: "eth",
        //       id: "E04-1-10",
        //       introduce: "introduce.sthnupl",
        //       navigation: "sthNUPLEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //币天销毁量
        //       path: "/",
        //       label: "menu2.cdd",
        //       fullName: "menu2.cdd2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "cdd",
        //       radius: "eth",
        //       id: "E05-1-2",
        //       introduce: "introduce.CDD",
        //       navigation: "CDDETH",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //币天销毁量分布 修改为BTC一样  币天销毁量年龄分布
        //       path: "/",
        //       label: "menu2.cddwave",
        //       fullName: "menu2.cddwave2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "cddwave",
        //       radius: "eth",
        //       id: "E05-1-3",
        //       introduce: "introduce.soag",
        //       navigation: "cddwaveEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //已花费输出平均寿命
        //       path: "/",
        //       label: "menu2.asol",
        //       fullName: "menu2.asol2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "asol",
        //       radius: "eth",
        //       id: "E05-1-4",
        //       introduce: "introduce.asol",
        //       navigation: "asolEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //已花费输出休眠平均天数
        //       path: "/",
        //       label: "menu2.dormancy",
        //       fullName: "menu2.dormancy",
        //       icon: "i igl-folderOpen",
        //       componentReq: "dormancy",
        //       radius: "eth",
        //       id: "E05-1-5",
        //       introduce: "introduce.dormancy",
        //       navigation: "dormancyEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //活跃度
        //       path: "/",
        //       label: "menu2.liveliness",
        //       fullName: "menu2.liveliness",
        //       icon: "i igl-folderOpen",
        //       componentReq: "liveliness",
        //       radius: "eth",
        //       id: "E05-1-6",
        //       introduce: "introduce.Liveliness",
        //       navigation: "livelinessEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //已花费输出盈利比
        //       path: "/",
        //       label: "menu2.sopr",
        //       fullName: "menu2.sopr2",
        //       icon: "i igl-folderOpen",
        //       componentReq: "sopr",
        //       radius: "eth",
        //       id: "E06-1-1",
        //       introduce: "introduce.soprEth",
        //       navigation: "soprEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest",
        //     },
        //     {
        //       //盈利供应量
        //       path: "/",
        //       label: "menu2.supplyprofit",
        //       fullName: "menu2.supplyprofit",
        //       icon: "i igl-folderOpen",
        //       componentReq: "supplyprofit",
        //       radius: "eth",
        //       id: "E06-1-2",
        //       introduce: "introduce.supplyProfitEth",
        //       navigation: "supplyProfitEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //盈利亏损量
        //       path: "/",
        //       label: "menu2.supplyloss",
        //       fullName: "menu2.supplyloss",
        //       icon: "i igl-folderOpen",
        //       componentReq: "supplyLoss",
        //       radius: "eth",
        //       id: "E06-1-3",
        //       introduce: "introduce.supplyLossEth",
        //       navigation: "supplyLossEth",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },

        //     {
        //       //盈利百分比
        //       path: "/",
        //       label: "menu2.supplyprofitPercent",
        //       fullName: "menu2.supplyprofitPercent",
        //       icon: "i igl-folderOpen",
        //       componentReq: "supplyprofitPercent",
        //       radius: "eth",
        //       id: "E06-1-4",
        //       introduce: "introduce.supplyProfitPercentEth",
        //       navigation: "supplyProfitPercentEth", //ProfitPercentEthsupply
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //     {
        //       //按余额分段的地址数分布 改为 地址数分布
        //       path: "/",
        //       label: "menu2.distribution",
        //       fullName: "menu2.distribution",
        //       icon: "i igl-folderOpen",
        //       componentReq: "distribution",
        //       radius: "eth",
        //       id: "E07-1-1-1",
        //       introduce: "introduce.balanceDistribution",
        //       navigation: "distributionEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //持有者地址的供应分布 改为 币数量分布
        //       path: "/",
        //       label: "menu2.supplyDistribution",
        //       fullName: "menu2.supplyDistribution",
        //       icon: "i igl-folderOpen",
        //       componentReq: "supplyDistribution",
        //       radius: "eth",
        //       id: "E07-1-1-2",
        //       introduce: "introduce.balanceDistribution",
        //       navigation: "supplyDistributionEth",
        //       assets: "ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //江卓尔60日累计涨幅
        //       path: "/",
        //       label: "menu2.technology6",
        //       fullName: "menu2.jzr60",
        //       icon: "i igl-folderOpen",
        //       componentReq: "jzr60",
        //       radius: "ETH",
        //       id: "1-6",
        //       // conditions: "arh", //不同请求方式筛选条件
        //       introduce: "introduce.jzr60",
        //       navigation: "jzr60",
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //2年移动平均价格乘数
        //       path: "/",
        //       label: "menu2.technology11",
        //       fullName: "menu2.ma730",
        //       icon: "i igl-folderOpen",
        //       componentReq: "ma730",
        //       radius: "eth",
        //       id: "1-11",
        //       introduce: "introduce.ma730",
        //       navigation: "ma730ETH", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //PI周期顶指标 ETH
        //       path: "/",
        //       label: "menu2.PiCycleTopIndicator",
        //       fullName: "menu2.PiCycleTopIndicator",
        //       icon: "i igl-folderOpen",
        //       componentReq: "PiCycleTopIndicator",
        //       radius: "eth",
        //       id: "1-12",
        //       introduce: "introduce.PiCycleTopIndicator",
        //       navigation: "piCycleTopEth", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest",
        //     },
        //     {
        //       //黄金比例乘数 ETH
        //       path: "/",
        //       label: "menu2.goldenRatioMult",
        //       fullName: "menu2.goldenRatioMult",
        //       icon: "i igl-folderOpen",
        //       componentReq: "goldenRatioMult",
        //       radius: "eth",
        //       id: "1-13",
        //       introduce: "introduce.goldenRatioMult",
        //       navigation: "goldenRatioMultEth", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //资金费率
        //       path: "/",
        //       label: "menu.technology13",
        //       fullName: "menu.technology13", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "fundingRateETH",
        //       radius: "eth",
        //       id: "E03-5",
        //       introduce: "introduce.fundingRate",
        //       navigation: "fundingRateETH", //导航组件名称
        //       assets: "BTCUSDT、ETHUSDT",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //注册用户
        //     },
        //     {
        //       //未平仓合约数
        //       path: "/",
        //       label: "menu.technology14",
        //       fullName: "menu.technology14", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "openInterestETH",
        //       radius: "eth",
        //       id: "E03-6",
        //       introduce: "introduce.openInterest",
        //       navigation: "openInterestETH", //导航组件名称
        //       assets: "BTCUSDT、ETHUSDT",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //合约主动买入量
        //       path: "/",
        //       label: "menu.technology15",
        //       fullName: "menu.technology15", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "takerlongshortRatioETH",
        //       radius: "eth",
        //       id: "E03-7",
        //       introduce: "introduce.takerlongshortRatio",
        //       navigation: "takerlongshortRatioETH", //导航组件名称
        //       assets: "BTCUSDT、ETHUSDT",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },

        //     {
        //       //时区购买力
        //       path: "/",
        //       label: "menu.tzbp",
        //       fullName: "menu.tzbp",
        //       icon: "i igl-folderOpen",
        //       componentReq: "tzbpEth",
        //       radius: "btc",
        //       id: "E03-1",
        //       introduce: "introduce.tzbp",
        //       navigation: "tzbpEth", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //买入大单挂单
        //       path: "/",
        //       label: "menu.bobp",
        //       fullName: "menu.bobp",
        //       icon: "i igl-folderOpen",
        //       componentReq: "bobp",
        //       radius: "btc",
        //       id: "E03-2",
        //       introduce: "introduce.bobp",
        //       navigation: "bobpEth", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //卖出大单挂单
        //       path: "/",
        //       label: "menu.bosp",
        //       fullName: "menu.bosp",
        //       icon: "i igl-folderOpen",
        //       componentReq: "bosp",
        //       radius: "btc",
        //       id: "E03-3",
        //       introduce: "introduce.bobp",
        //       navigation: "bospEth", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //成交量分布图
        //       path: "/",
        //       label: "menu.volumeProfile",
        //       fullName: "menu.volumeProfile", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "volumeProfileETH",
        //       radius: "ETH",
        //       id: "E03-8",
        //       introduce: "introduce.volumeProfile",
        //       navigation: "volumeProfileETH", //导航组件名称
        //       assets: "BTCUSDT、ETHUSDT",
        //       interval: "menu.interval3",
        //       type: "L3",
        //       authority: "advance",
        //     },
        //     {
        //       //交易所余额
        //       path: "/",
        //       label: "menu.exchange10",
        //       fullName: "menu.exchange10",
        //       icon: "i igl-folderOpen",
        //       componentReq: "exchange",
        //       radius: "btc",
        //       id: "E03-4",
        //       introduce: "introduce.exchange1",
        //       navigation: "exchangeETH", //导航组件名称
        //       assets: "BTC、ETH",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered",
        //     },
        //   ],
        // },
        { //稳定币         
          label: "稳定币",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "W1",
          children: [
            {
              //总流通量
              path: "/",
              label: "menu2.cstotal",
              fullName: "menu2.cstotal",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-1",
              introduce: "introduce.circulationTotalCSupply",
              navigation: "circulationTotalCSupply",
              assets: "USDC、USDT、BUSD",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDC
              path: "/",
              label: "menu2.csusdc",
              fullName: "menu2.csusdc",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-2",
              introduce: "introduce.circulationUSDC", //无介绍
              navigation: "circulationUSDC",
              assets: "USDC",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDT
              path: "/",
              label: "menu2.csusdt",
              fullName: "menu2.csusdt",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-3",
              introduce: "introduce.circulationUSDT", //无介绍
              navigation: "circulationUSDT",
              assets: "USDT",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //BUSD
              // path: "/",
              label: "menu2.csbusd",
              fullName: "menu2.csbusd",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-4",
              introduce: "introduce.circulationBUSD", //无介绍
              navigation: "circulationBUSD",
              assets: "BUSD",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDC铸造量
              path: "/",
              label: "menu2.USDCCasting",
              fullName: "menu2.USDCCasting2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "USDC",
              id: "w2-2",
              introduce: "introduce.USDCCasting", //无介绍
              navigation: "mintedUSDC",
              assets: "USDC",
              interval: "menu.interval3", //历史数据
              type: "L3",
              authority: "advance",
            },
            {
              //USDT铸造量
              path: "/",
              label: "menu2.USDTCasting",
              fullName: "menu2.USDTCasting2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "USDT",
              id: "w2-1",
              introduce: "introduce.USDTCasting", //无介绍
              navigation: "mintedUSDT",
              assets: "USDT",
              interval: "menu.interval3", //历史数据
              type: "L3",
              authority: "advance",
            },

            {
              //BUSD铸造量
              path: "/",
              label: "menu2.BUSDCasting",
              fullName: "menu2.BUSDCasting2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "BUSD",
              id: "w2-3",
              introduce: "introduce.BUSDCasting", //无介绍
              navigation: "mintedBUSD",
              assets: "BUSD",
              interval: "menu.interval3", //历史数据
              type: "L3",
              authority: "advance",
            },
            { //USDC交易量
              path: "/",
              label: "menu2.usdc",
              fullName: "menu2.usdc2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-1",
              introduce: "introduce.dayUsdc", //无介绍
              navigation: "USDC",
              assets: "USDC",
              interval: "menu.interval3", //无介绍
              type: "L1",
              authority: "guest", //匿名用户
            },
            {//USDT交易量
              path: "/",
              label: "menu2.usdt",
              fullName: "menu2.usdt2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-2",
              introduce: "introduce.dayUsdt", //无介绍
              navigation: "USDT",
              assets: "USDT",
              interval: "menu.interval3", //无
              type: "L1",
              authority: "guest", //匿名用户
            },
            {//BUSD交易量
              path: "/",
              label: "menu2.busd",
              fullName: "menu2.busd2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-3",
              introduce: "introduce.dayBusd", //无介绍
              navigation: "BUSD",
              assets: "BUSD",
              interval: "menu.interval3", //1天
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDC大额交易
              path: "/",
              label: "menu2.USDCMonitoring",
              fullName: "menu2.USDCMonitoring2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w4-1",
              introduce: "introduce.bigUsdc",
              navigation: "USDCMonitoring",
              assets: "USDC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册
            },
            {
              //USDT大额交易
              path: "/",
              label: "menu2.USDTMonitoring",
              fullName: "menu2.USDTMonitoring2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w4-2",
              introduce: "introduce.bigUsdt",
              navigation: "USDTMonitoring",
              assets: "USDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册
            },
            {
              //BUSD大额交易
              path: "/",
              label: "menu2.BUSDMonitoring",
              fullName: "menu2.BUSDMonitoring2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w4-3",
              introduce: "introduce.bigBusd",
              navigation: "BUSDMonitoring",
              assets: "BUSD",
              interval: "menu.interval3", //1天
              type: "L2",
              authority: "registered", //注册
            },
          ],
        },
        { //宏观经济指标导航         
          label: "宏观经济指标",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "H1",
          children: [
            {//货币供应量              
              path: "/",
              label: "menu.MoneyStockMeasures",
              fullName: "menu.MoneyStockMeasures", //全名
              icon: "i igl-folderOpen",
              componentReq: "MoneyStockMeasures",
              id: "H1-1",
              introduce: "introduce.MoneyStockMeasures",
              navigation: "MoneyStockMeasures",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //私营部门贷款
              path: "/",
              label: "menu.loanPsi",
              fullName: "menu.loanPsi", //全名
              icon: "i igl-folderOpen",
              componentReq: "loanPsi",
              id: "3-7",
              introduce: "introduce.loanPsi",
              navigation: "loanPsi",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //私人债务占GDP比重
              path: "/",
              label: "menu.loanGdp",
              fullName: "menu.loanGdp", //全名
              icon: "i igl-folderOpen",
              componentReq: "loanGdp",
              id: "3-8",
              introduce: "introduce.loanGdp",
              navigation: "loanGdp",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //国债收益率
              path: "/",
              label: "menu.USTreasuriesYields",
              fullName: "menu.USTreasuriesYields", //全名
              icon: "i igl-folderOpen",
              componentReq: "USTreasuriesYields",
              id: "H2-1",
              introduce: "introduce.USTreasuriesYields",
              navigation: "USTreasuriesYields",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //纳斯达克指数
              path: "/",
              label: "menu.macro1",
              fullName: "menu.macro1", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQohlc",
              id: "H3-1",
              introduce: "introduce.NDAQohlc",
              navigation: "ndaqOhlc",
              assets: "无",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //纳斯达克/BTC日K线 改为 纳斯达克指数 vs BTC
              path: "/",
              label: "menu.macro2",
              fullName: "menu.macro2", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H3-2",
              introduce: "introduce.NDAQBTCPrice",
              navigation: "NdaqBtcDayKline",
              assets: "无",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //每周经济指数
              path: "/",
              label: "menu.wei",
              fullName: "menu.wei", //全名
              icon: "i igl-folderOpen",
              componentReq: "wei",
              id: "H4-1",
              introduce: "introduce.wei",
              navigation: "wei",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //市场快讯 金十数据
              path: "/",
              label: "menu.quickNews",
              fullName: "menu.quickNews", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H5-1",
              introduce: "introduce.quickNews",
              navigation: "quickNews",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //财经日历 金十数据
              path: "/",
              label: "menu.economics",
              fullName: "menu.economics", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H5-2",
              introduce: "introduce.quickNews",
              navigation: "economics",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },


          ],
        },

      ],
      newMEnu: [
        { //BTC币种         
          label: "menu.BTCMenu",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "B1",
          children: []
        },
        // { //ETH币种         
        //   label: "menu.ETHMenu",
        //   icon: "i itubiao2",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "E1",
        //   children: []
        // },
        { //稳定币         
          label: "menu.stableMenu",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "W1",
          children: []
        },
        { //宏观经济指标导航         
          label: "menu.macroscopicMenu",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "H1",
          children: []
        },


      ],
      activeMenuItem: "B01-1-4", // 当前选中的菜单项
      menuRefHeight: 0, // 菜单的高度
      menuChildren: [],
      topArr: [],//元素自身距离父级的高度、
      scrollListenerEnabled: true,//是否启用滚动事件监听
      flag: false,
      BTCmenu: [],
      ETHmenu: [],
      stableMenu: [],
      macroscopicMenu: [],
      oldMenu: []

    };
  },

  created() {
    this.handelNewMenu()//处理需要渲染的数据
  },
  mounted() {
    this.flag = sessionStorage.getItem("Whether")
    if (this.flag) {
      this.menuId = "B01-1-4"
    } else {
      this.menuId = localStorage.getItem("open")
    }
    this.handleMenuSelect(this.menuId)
    this.handelIntroduce()
    this.handelScrollHeight()
    this.restaurants = this.handelMenu(this.menuChildren)
    sessionStorage.setItem("Whether", "true");
  },
  watch: {
    // 监听语言切换
    "$i18n.locale"(newValue) {


      this.restaurants = this.handelMenu(this.menuChildren)

    },

  },
  computed: {
    menuStyle() {
      return {
        position: 'fixed',
        left: '0',
        top: '0',
        height: this.menuRefHeight + 'px',
      };
    },
    contentStyle() {
      return {
        paddingLeft: this.menuRefHeight + 'px',
      };
    },
  },
  methods: {

    //处理接口介绍换行
    handelIntroduce(introduce) {

      if (this.$t(introduce).indexOf("///") !== -1) {
        this.newIntroduce = this.$t(introduce).split("///");
        //计算公式 和单位 不显示
        var filteredArray = this.$t(introduce).split("///").filter(item => {
          return !item.includes("计算公式") && !item.includes("千=K") && !item.includes("Calculation formula:") && !item.includes("thousands =K");
        })

        return filteredArray

        // return this.$t(introduce).split("///");
      } else {
        this.newIntroduce = [this.$t(this.introduce)];

        return this.$t(introduce)
      }


    },

    //回到顶部
    scrollToTop() {
      const container = this.$refs.menuItemBox;
      const container1 = this.$refs.wrapper;
      container.scrollTop = 0;
      container1.scrollTop = 0;
    },
    menuClose(index) { //保留一个菜单总保持打开状态

      // if(this.$refs.elMenuRef.openedMenus.length < 1){
      //   this.$refs.elMenuRef.open(index)
      // }
    },
    //搜素框默认显示的内容
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    //查找有关键字的项目
    createStateFilter(queryString) {

      return (state) => {

        return state.label.toLowerCase().includes(queryString.toLowerCase());
      };
    },


    // 按照搜索格式调整Menu
    handelMenu(menu) {
      let newMenu = []
      menu.map((item, index) => {

        newMenu.push({ value: item.id, label: this.$t(item.label), index: index })
      })
      return newMenu
    },


    //选中导航搜索结果中的某一项
    handleSelect(item) {

      let newObj = item;
      if (!item.label) {
        //点击了搜索图标
        newObj = this.restaurants.find((item1) => item1.value == item.value);
      }
      this.handleMenuSelect(newObj.value)
      this.state = "";
    },
    //点击左侧菜单右侧内容对应滚动位置
    handleMenuSelect(index) {
      this.activeMenuItem = index
      this.scrollListenerEnabled = false
      const contentRef = this.$refs.wrapper;
      const menuRef = this.$refs[`menu${index}`][0]

      menuRef.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });



      setTimeout(() => {//当点击左侧菜单项目的时候 就不执行滚动函数的内容
        this.scrollListenerEnabled = true;
      }, 500); // 这里使用一个适当的延迟时间，根据实际情况进行调整




    },
    //监听右侧滚动位置  高亮左侧导航栏
    handleContentScroll(event) {

      this.flag = true
      if (!this.scrollListenerEnabled) {
        return;
      }
      const contentRef = this.$refs.wrapper;
      if (!contentRef) return;
      const menuBox = this.$refs.menuItemBox
      const scrollTop = contentRef.scrollTop; // 获取右侧内容的滚动位置


      let AIndex = this.topArr.findIndex((item, index) => {
        return (
          scrollTop > this.topArr[index - 1] &&
          scrollTop < this.topArr[index]
        );
      });
      if (AIndex < 0) {
        AIndex = 0
      }

      this.activeMenuItem = this.menuChildren[AIndex].id
      // const activeItem = document.querySelector('.el-menu-item.is-active');//拿到高龄元素
      // activeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });//滚动到高亮元素      

    },
    handelScrollHeight() {
      //扁平化导航      
      this.newMEnu.forEach(item => {
        if (item.children) {
          this.menuChildren.push(...item.children)
        }
      })
      this.newMEnu.map((item) => {
        item.children.map((subItem) => {

          if (subItem.id) {
            const element = this.$refs['menu' + subItem.id][0]; // 获取对应的元素对象
            const rect = element.getBoundingClientRect(); // 获取元素的位置和尺寸信息
            this.topArr.push(element.offsetTop)
          }


        });
      });

    },
    //扁平化导航数组 递归
    handelAllMenu(arr) {
      var result = [];
      arr.forEach((item) => {
        if (!item.children) {
          result.push(item);
        } else {
          var nestedItems = this.handelAllMenu(item.children);
          result = result.concat(nestedItems);
        }
      });

      return result;
    },
    //拿取内存中最新的导航进行处理数据生成新导航
    handelNewMenu() {
      //拿到侧边导航的每个分类导航
      this.BTCmenu = JSON.parse(localStorage.getItem("BTCMenu"))
      this.ETHmenu = JSON.parse(localStorage.getItem("ETHmenu"))
      this.stableMenu = JSON.parse(localStorage.getItem("stableMenu"))
      this.macroscopicMenu = JSON.parse(localStorage.getItem("macroscopicMenu"))
      this.newMEnu[0].children = this.handelAllMenu(this.BTCmenu)
      // this.newMEnu[1].children = this.handelAllMenu(this.ETHmenu)
      this.newMEnu[1].children = this.handelAllMenu(this.stableMenu)
      this.newMEnu[2].children = this.handelAllMenu(this.macroscopicMenu)
    
      // --------------地址数、币数量等加上对应分类-----------------------------
      this.oldMenu = this.handelAllMenu(this.newMEnu1)
      //需要更换名字的几个导航项
      let arr = `B08-1-1-1,B08-1-1-2,B08-1-2-1,B08-1-2-2,B08-1-3-1,B08-1-3-2,B08-1-4-1,B08-1-4-2,B08-1-5-1,B08-1-5-2,B08-1-6-1,B08-1-6-2,B08-1-6-3,B08-1-6-4,B08-1-6-5,B08-1-6-6,B08-1-6-7,B08-1-6-8,B08-1-7-1,B08-1-7-2,B08-1-7-3,B08-1-7-4,B08-1-7-5,B08-1-7-6,B08-1-7-7,B08-1-7-8`
      arr = arr.split(",")

      let replaceArr = []//筛选出替换的对象
      arr.map((item) => {
        replaceArr.push(this.oldMenu.find((itemB) => {
          return itemB.id == item
        }))

      })
      // 使用 map() 方法替换指定项
      this.newMEnu[0].children = this.newMEnu[0].children.map( (itemA) =>{
        var matchingItem = replaceArr.find((itemB)=>{
          return itemA.id === itemB.id;
        });

        if (matchingItem) {
          return matchingItem;
        } else {
          return itemA;
        }
      });




    }




  },
  beforeDestroy() {

    localStorage.setItem("Whether", "false");
  }
};